"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSection = void 0;
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var lodash_1 = require("lodash");
var CalculateItem_1 = require("./CalculateItem");
var CalculatorHelpers_1 = __importDefault(require("./CalculatorHelpers"));
function calculateSection(sectionModel, variableService, discountService, billingScheduleOrchestrator, currency, cacheResults) {
    var e_1, _a;
    var _b, _c;
    var oneOffTotalPreTax = 0;
    var oneOffTotalTaxable = 0;
    var oneOffCumulativeDiscount = 0;
    var recurringTotals = {};
    var calculatorHelpers = new CalculatorHelpers_1.default(discountService);
    if (sectionModel.items != null) {
        try {
            for (var _d = __values(sectionModel.items), _e = _d.next(); !_e.done; _e = _d.next()) {
                var item = _e.value;
                var calculatedItem = (0, CalculateItem_1.calculateItem)(item, variableService, discountService, billingScheduleOrchestrator, currency, cacheResults);
                var shouldIncludeInSectionTotal = calculatedItem != null && (!((_b = item.interactive) === null || _b === void 0 ? void 0 : _b.isOptional) || ((_c = item.interactive) === null || _c === void 0 ? void 0 : _c.isOptionalSelected));
                if (shouldIncludeInSectionTotal) {
                    if (calculatedItem.billingSchedule.type === Types_1.BillingScheduleType.OneOff) {
                        oneOffTotalTaxable += calculatedItem.taxable;
                        oneOffTotalPreTax += calculatedItem.preTax;
                        oneOffCumulativeDiscount += calculatedItem.preDiscount - calculatedItem.preTax;
                    }
                    else {
                        var frequency = calculatedItem.billingSchedule.frequency;
                        var total = recurringTotals[frequency];
                        if (total) {
                            total.taxable += calculatedItem.taxable;
                            total.preTax += calculatedItem.preTax;
                            total.cumulativeDiscount += calculatedItem.preDiscount - calculatedItem.preTax;
                        }
                        else {
                            recurringTotals[frequency] = {
                                taxable: calculatedItem.taxable,
                                preTax: calculatedItem.preTax,
                                cumulativeDiscount: calculatedItem.preDiscount - calculatedItem.preTax,
                            };
                        }
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    var sectionDiscount = sectionModel.discount;
    var oneOffTotalPreDiscount = oneOffTotalPreTax;
    oneOffTotalPreTax = calculatorHelpers.applyDiscount(oneOffTotalPreTax, sectionDiscount);
    oneOffTotalTaxable = calculatorHelpers.applyDiscount(oneOffTotalTaxable, sectionDiscount);
    var oneOffDiscount = oneOffTotalPreDiscount - oneOffTotalPreTax;
    oneOffCumulativeDiscount += oneOffDiscount;
    if (cacheResults) {
        sectionModel.$cost = oneOffTotalPreTax;
        sectionModel.$preDiscount = oneOffTotalPreDiscount;
    }
    var recurringTotalsWithDiscounts = (0, lodash_1.mapValues)(recurringTotals, function (frequency) {
        if (frequency) {
            var recurringTotalPreDiscount = frequency.preTax;
            var recurringTotalPreTax = calculatorHelpers.applyDiscount(frequency.preTax, sectionDiscount);
            var recurringTotalTaxable = calculatorHelpers.applyDiscount(frequency.taxable, sectionDiscount);
            var recurringDiscount = recurringTotalPreDiscount - recurringTotalPreTax;
            return {
                taxable: calculatorHelpers.roundOffMoney(recurringTotalTaxable, currency),
                preTax: calculatorHelpers.roundOffMoney(recurringTotalPreTax, currency),
                sectionDiscount: calculatorHelpers.roundOffMoney(recurringDiscount, currency),
                preDiscount: calculatorHelpers.roundOffMoney(recurringTotalPreDiscount, currency),
                cumulativeDiscount: calculatorHelpers.roundOffMoney(recurringDiscount + frequency.cumulativeDiscount, currency),
            };
        }
        return {
            taxable: 0,
            preTax: 0,
            sectionDiscount: 0,
            preDiscount: 0,
            cumulativeDiscount: 0,
        };
    });
    return {
        taxable: calculatorHelpers.roundOffMoney(oneOffTotalTaxable, currency),
        preTax: calculatorHelpers.roundOffMoney(oneOffTotalPreTax, currency),
        sectionDiscount: calculatorHelpers.roundOffMoney(oneOffDiscount, currency),
        preDiscount: calculatorHelpers.roundOffMoney(oneOffTotalPreDiscount, currency),
        recurringTotals: recurringTotalsWithDiscounts,
        cumulativeDiscount: calculatorHelpers.roundOffMoney(oneOffCumulativeDiscount, currency),
    };
}
exports.calculateSection = calculateSection;
